<div ng-hide="vm.ready" class="alert alert-info spacer-top">
    <h3><i class="fa fa-spinner fa-spin"></i> Datei wird geladen</h3>
</div>
<!-- Menubar -->
<div class="row spacer-top" ng-show="vm.ready">
    <div class="col-xs-12">
        <!-- PDF viewer actions-->
        <div class="pull-left">
            <button class="btn btn-info" ng-click="vm.zoomIn()" uib-tooltip="Hineinzoomen"><i
                class="fa fa-search-plus"></i></button>
            <button class="btn btn-info" ng-click="vm.zoomOut()" uib-tooltip="Herauszoomen"><i
                class="fa fa-search-minus"></i></button>
            <button class="btn btn-info" ng-click="vm.rotatePage()" uib-tooltip="Dokument drehen"><i
                class="fa fa-rotate-right"></i></button>
            <button class="btn btn-info" ng-click="vm.previousPage()" uib-tooltip="Zurückblättern"><i
                class="fa fa-arrow-left"></i></button>
            <!--  Seite: {{vm.currentpage}} / {{vm.maxpc}}  -->
            <form style="display: inline" class="form-horizontal">
                <label for="pagenr"> Seite: </label>
                <input type="number" class="form-control"
                       style="display: inline; width: 4em"
                       width="5em" name="pagenr" id="pagenr"
                       ng-change="vm.gotoPage()"
                       ng-model="vm.currentpage">
                <label>/{{vm.maxpc}}</label></form>
            <button class="btn btn-info" ng-click="vm.nextPage()" uib-tooltip="Vorblättern"><i
                class="fa fa-arrow-right"></i></button>
        </div>
        <!-- document assigment menu -->
        <div class="pull-right col-xs-6">
            <!-- scan sorter -->
            <span ng-show="vm.filemode === 'scan'">
                <button class="btn btn-success" ng-click="vm.assignCat('patient')"
                        uib-tooltip="Dokument Patient zuordnen">
                    <i class="fa fa-arrow-down"></i><i class="fa fa-user"></i>
                </button>
                <button class="btn btn-success" ng-click="vm.assignCat('generic')"
                        uib-tooltip="Allgemeines Dokument zuordnen">
                    <i class="fa fa-arrow-down"></i><i class="fa fa-book"></i>
                </button>
                <button class="btn btn-warning"
                        data-ng-disabled="vm.formDisabled(vm.file)"
                        ng-click="vm.finish()"
                        uib-tooltip="Dokument abschliessen">
                    <i class="fa fa-check"></i> Dokument abschließen
                </button>
            </span>
            <!-- scan signoff -->
            <span ng-show="vm.filemode === 'signoff'">
                <span class="input-group">
                    <input type="text"  class="form-control" ng-model="vm.file.signature" placeholder="Signatur">
                    <span class="input-group-btn">
                        <button class="btn btn-warning "
                                data-ng-disabled="vm.formSignoffDisabled(vm.file)"
                                ng-click="vm.finishSignoff()"
                                uib-tooltip="Dokument abschliessen">
                        <i class="fa fa-check"></i> Dokument vidieren
                        </button>
                    </span>
                </span>

            </span>
        </div>
    </div>
</div>


<!-- ************************************************************ -->
<!-- Viewer and actions                                           -->
<!-- ************************************************************ -->

<div class="row spacer-top">
    <div class="col-xs-12 col-lg-6">
        <div class="alert alert-info spacer-top spacer-bottom" ng-hide="vm.docready">
            <h3><i class="fa fa-spinner fa-spin"></i> Dokument wird geladen ...</h3>
        </div>
        <!-- PDF Viewer -->
        <pdf-viewer ng-show="vm.docready"
            delegate-handle="scans-pdf-container"
            url="pdfUrl"
            scale="1.2"
            show-toolbar="false">
        </pdf-viewer>
    </div>

    <div class="col-xs-12 col-lg-6">
        <form class="form-vertical spacer-top">
            <!-- keywords -->
            <div class="row" ng-show="vm.file.doccat">
                <div class="col-xs-12">
                    <div class="form-group">
                        <label for="dockeywords">Stichworte</label>
                        <tags-input ng-model="vm.file.keywords"
                                    display-property="text"
                                    id="filekeywords{{$index}}"
                                    add-on-paste="true"
                                    add-on-comma="false"
                                    add-on-enter="true"
                                    min-length="1"
                                    ng-blur="vm.saveKeywords()"
                                    enable-editing-last-tag="true"
                                    add-from-autocomplete-only="false"
                                    replace-spaces-with-dashes="false"
                                    template="filetag-template">
                            <auto-complete source="vm.getTags($query)"
                                           min-length="1"
                                           load-on-focus="true"
                                           load-on-empty="false"
                                           load-on-down-arrow="true"
                                           max-results-to-show="32"
                                           select-first-match="true"
                                           template="filetagautocomplete-template">
                            </auto-complete>
                        </tags-input>
                    </div>
                </div>
            </div>

            <!--on-tag-added="vm.assignKeyword($tag)"-->
            <!-- ************************************************************ -->
            <!-- Patient/Client Document Actions                              -->
            <!-- ************************************************************ -->

            <!-- patient docs -->
            <div class="row" ng-show="vm.file.doccat === 'patient'">
                <div class="col-xs-12 col-md-6">

                    <div ng-hide="vm.file.clientid || vm.file.patientid">
                        <label for="clientsearch">{{vm.kunde}}</label>
                        <clientsearch parentsave="vm.saveClient(client, mode)" mode="{{vm.clientmode}}"
                                      id="clientsearch"></clientsearch>
                    </div>
                    <div ng-show="vm.file.patientid">
                        <label for="patient">Patient</label>

                        <div class="input-group">
                            <input type="text" class="form-control"
                                   id="patient"
                                   readonly
                                   ng-model="vm.file.patientfname">
                            <span class="input-group-btn">
                                <button class="btn btn-danger"
                                        ng-click="vm.clearPatient()"><i class="fa fa-remove"></i>
                                </button>
                            </span>
                        </div>
                    </div>
                    <div ng-show="vm.file.clientid">
                        <label for="client">Kunde</label>

                        <div class="input-group">
                            <input type="text" class="form-control"
                                   id="client"
                                   readonly
                                   ng-model="vm.file.clientfname">
                            <span class="input-group-btn">
                                <button class="btn btn-danger"
                                        ng-click="vm.clearClient()"><i class="fa fa-remove"></i>
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
                <!-- PatientDokument type -->
                <div class="col-xs-12 col-md-6">
                    <div class="form-group">
                        <label for="patdoctype">{{vm.kunden}}-Dokumenttyp</label>
                        <select id="patdoctype" ng-model="vm.file.type" class="form-control" ng-change="vm.save()">
                            <option ng-repeat="v in vm.dmspatientcat" value="{{v}}">{{v}}</option>
                        </select>
                    </div>
                </div>

                <div class="form-group col-xs-12" ng-show="vm.file.patientid">
                    <label for="client">Diagnosen</label>
                    <diagnosesedit diagnoses="vm.client.diagnoses" parentsave="vm.diagClientSave()"></diagnosesedit>
                </div>

                <!-- Logging -->
                <div class="form-group col-xs-12 col-md-6">
                    <button type="button" ng-click="vm.addLog()"
                            uib-tooltip="Logeintrag für Patienten erstellen"
                            class="btn btn-success form-control"><i class="fa fa-plus"></i> {{vm.kunden}}-Logeintrag
                    </button>
                </div>
                <!-- PatTodo -->
                <div class="form-group col-xs-12 col-md-6">
                    <button type="button" ng-click="vm.addReminder()" uib-tooltip="Erinnerung für {{vm.kunden}} erstellen"
                            class="btn btn-success form-control"><i class="fa fa-plus"></i> {{vm.kunden}}-Erinnerung/Todo
                    </button>
                </div>


                <!-- Befunde nachtragen -->
                <div class="col-xs-12" ng-show="vm.file.patientid">
                    <h4>Untersuchungsergebnisse nachtragen</h4>
                    <addexamdiagnoses patientid="vm.file.patientid"></addexamdiagnoses>
                </div>


            </div>


            <!-- ************************************************************ -->
            <!-- Generic Document Actions                                     -->
            <!-- ************************************************************ -->

            <div class="row" ng-show="vm.file.doccat === 'generic'">
                <div class="col-xs-12">
                    <div class="form-group">
                        <label for="gendoctype">Allgemeiner Dokumenttyp</label>
                        <select id="gendoctype" ng-model="vm.file.type" class="form-control" ng-change="vm.save()">
                            <option ng-repeat="v in vm.dmsgencat" value="{{v}}">{{v}}</option>
                        </select>
                    </div>
                </div>
            </div>

        </form>

    </div>


</div>


<!-- tag template -->
<script type="text/ng-template" id="filetag-template">
    <div class="tag-template" style="z-index: 10000">
        <div class="right-panel">
            <span>{{$getDisplayText()}}</span>
            <a class="remove-button" ng-click="$removeTag()">&#10006;</a>
        </div>
    </div>
</script>

<!-- tag autocomplete template -->
<script type="text/ng-template" id="filetagautocomplete-template">
    <div class="filetagautocomplete-template" style="z-index: 10000">
        <div>
            <span ng-bind-html="$highlight($getDisplayText())">{{text}}</span>
        </div>
    </div>
</script>